/**
 * Common props shared between most components.
 * Note: individual coponents may override these props if needed.
 * @type  {Object}
 */
export default {
  props: {
    fieldId: {
      type: String,
      default: null,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    validation: {
      type: [String, Object],
      default () {
        return {}
      }
    },
    // Individual components may override the default value
    showUiValidation: {
      type: String,
      default: 'both',
      validator: function (value) {
        return ['valid', 'invalid', 'both'].indexOf(value) > -1
      }
    },
    errorMessages: {
      type: [Object, String],
      default: function () {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/fieldProps.js